/* eslint-disable no-new */
import Vue from 'vue/dist/vue.esm';
import VueResource from 'vue-resource';

import { EventBus } from '../../configuration';

import categories from './categories.json';

const { hostname } = window.location;

Vue.use(VueResource);
[...document.querySelectorAll('[data-select]')].forEach(el => {
  const dataEndpoint = el.getAttribute('data-endpoint');

  new Vue({
    el,
    data() {
      return {
        data: null,
        items: [],
        selected: { id: 'all', name: this.allCategoriesOptionText },
        isOpen: false,
        allCategoriesOptionText: '',
      };
    },
    computed: {
      isLocalEnv() {
        return hostname === 'localhost';
      },
      inviqaSelectClasses() {
        return {
          'inviqa-select--is-open': this.isOpen,
        };
      },
      allCategoriesOption() {
        return this.$refs.all;
      },
      selectedOptionText() {
        const option = this.items.filter(item => {
          return item.id === this.selected;
        });

        return option[0] ? option[0].name : this.allCategoriesOptionText;
      },
    },
    methods: {
      setCategoryOnLoad() {
        const { hash } = window.location;
        const urlCategory = new URLSearchParams(window.location.search).get('category');
        if (hash || urlCategory) {
          this.items.map(item => {
            if (hash.replace('#', '') === item.name.toLowerCase() || urlCategory === item.name.toLowerCase()) {
              EventBus.$emit('categorySelected', item.id);
            }
            return item;
          });
        }
      },

      updateUrl(cat) {
        if (cat === 'all') window.location.hash = '';
        this.items.map(item => {
          if (item.id === cat) window.history.replaceState('', '', `#${item.name.toLowerCase()}`);
          return item;
        });
      },

      processData() {
        this.data.forEach(item => {
          if (item.attributes.name) {
            this.items.push({
              name: item.attributes.name,
              id: item.id,
            });
          }
        });
      },
      init(response) {
        this.data = response.body.data;
        this.allCategoriesOptionText = this.allCategoriesOption.innerHTML;
        this.processData();
        this.setCategoryOnLoad();
      },
      toggleSelect() {
        this.isOpen = !this.isOpen;
      },
      selectOption(option) {
        this.selected = option.id;
        EventBus.$emit('categorySelected', option.id);
        this.toggleSelect();
      },
    },

    mounted() {
      if (this.isLocalEnv) {
        this.init(categories);
      } else {
        this.$http
          .get(dataEndpoint)
          .then(response => {
            this.init(response);
          })
          .catch(error => console.log(error)); // eslint-disable-line no-console
      }
    },

    created() {
      EventBus.$on('categorySelected', cat => {
        this.updateUrl(cat);
        this.selected = cat;
      });
    },
  });
});
